import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { router } from './routes';
import { store } from './store';
import { AuthGate } from './features/auth/AuthGate';
import { GenerationProvider } from './components/generation/state/useGenerationState';
import RightPanelWrapper from './components/panels/RightPanelWrapper';
import { GenerationQueueWindow } from './components/generation/GenerationQueueWindow';
import { registerSpaNavigate } from './utils/navigation';
import './App.css';
import './styles/z-index.css';
import './styles/accent.css';
import './styles/auth-pages.css';
import './styles/buttons.css';
import './styles/form-controls.css';
import './styles/icons.css';

registerSpaNavigate((path) => {
  void router.navigate(path);
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // 失敗時のリトライを無効化
      refetchOnWindowFocus: false, // ウィンドウフォーカス時の自動再取得を無効化
      refetchOnMount: false, // マウント時の自動再取得を無効化
      staleTime: 1000 * 60 * 5, // 5分間はキャッシュを新鮮とみなす
    },
  },
});

export default function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <AuthGate>
          <GenerationProvider>
            <RouterProvider router={router} />
            <RightPanelWrapper />
            <GenerationQueueWindow />
          </GenerationProvider>
        </AuthGate>
      </QueryClientProvider>
    </Provider>
  );
}
